// ===================================
// BANNER MONAD SLIDER - OHNE REQUIRE/IMPORT
// ===================================

// KORRIGIERT: Alle require/import durch globale Variablen ersetzt
// const Flickity = require('../vendor/flickity'); // ← ENTFERNT
// import { Tween } from '../vendor/gsap'; // ← ENTFERNT
// import Media from '../bases/media.js'; // ← ENTFERNT
// import {$, $$} from '../abstract/dom.js'; // ← ENTFERNT

// ===================================
// DOM HELPER FUNCTIONS
// ===================================

function $(selector, context = document) {
	return context.querySelector(selector)
}

function $$(selector, context = document) {
	return Array.from(context.querySelectorAll(selector))
}

// ===================================
// MEDIA QUERY HELPER (ERSATZ FÜR Media.js)
// ===================================

const MediaHelper = {
	// Breakpoint Definitionen (angepasst an Ihr SCSS)
	breakpoints: {
		xs: '26em',    // 416px
		s: '36em',     // 576px  
		m: '52em',     // 832px
		l: '72em',     // 1152px
		xl: '104em'    // 1664px
	},
	
	isAbove: function(breakpoint) {
		if (!this.breakpoints[breakpoint]) {
			console.warn(`Breakpoint '${breakpoint}' nicht definiert`)
			return false
		}
		
		// Konvertiere em zu px (16px base)
		const bpValue = parseFloat(this.breakpoints[breakpoint]) * 16
		return window.innerWidth >= bpValue
	},
	
	isBelow: function(breakpoint) {
		return !this.isAbove(breakpoint)
	},
	
	// Debugging-Hilfsfunktion
	getCurrentBreakpoint: function() {
		const width = window.innerWidth
		
		for (const [name, value] of Object.entries(this.breakpoints).reverse()) {
			const bpValue = parseFloat(value) * 16
			if (width >= bpValue) {
				return name
			}
		}
		return 'base'
	}
}

// ===================================
// VERFÜGBARKEITS-PRÜFUNGEN
// ===================================

function checkDependencies() {
	const missing = []
	
	if (typeof Flickity === 'undefined') {
		missing.push('Flickity')
	}
	
	if (typeof Tween === 'undefined') {
		missing.push('Tween/GSAP')
	}
	
	if (missing.length > 0) {
		console.error('❌ Fehlende Dependencies für Banner Monad Slider:', missing)
		console.log('💡 Stelle sicher, dass alle vendor files geladen sind')
		return false
	}
	
	console.log('✅ Alle Dependencies für Banner Monad Slider verfügbar')
	return true
}

// ===================================
// BANNER START MONADS SLIDER
// ===================================

function initBannerStartMonads() {
	if (!checkDependencies()) return
	
	console.log('🎠 Initialisiere Banner Start Monads')
	
	$$('.banner-start-monads').forEach((slider) => {
		try {
			const monadHolds = $$('.hold-image', slider)
			const miniMonads = $$('.mini-monad', slider)
			const slideTexts = $$('.slide-text', slider)
			let userPaused = false // neuer Flag

			console.log('🔧 Start Monad Slider Setup:', {
				monadHolds: monadHolds.length,
				miniMonads: miniMonads.length,
				slideTexts: slideTexts.length
			})

			const flkty = new Flickity($('.flickity-flow', slider), {
				contain: true,
				wrapAround: true,
				autoPlay: false,
				adaptiveHeight: true,
				prevNextButtons: true,
				pageDots: true,
				pauseAutoPlayOnHover: false,
				selectedAttraction: 0.0125,
				friction: 0.2,
				on: {
					ready() {
						console.log('✅ Start Monad Slider ready')
						
						// update scroll CB wrt progress
						var positionX = -this.x - this.slides[0].target
						var progress = positionX / this.slidesWidth
						this.options.on.scroll.call(this, progress)

						// set prev/next buttons to non focusable
						if (this.prevButton && this.prevButton.element) {
							this.prevButton.element.tabIndex = -1
						}
						if (this.nextButton && this.nextButton.element) {
							this.nextButton.element.tabIndex = -1
						}

						// set up play/pause button
						const toggleButton = document.createElement('button')
						toggleButton.setAttribute('aria-label', 'Wiedergabe starten')
						const toggleButtonItem = document.createElement('li')
						toggleButtonItem.appendChild(toggleButton)
						toggleButtonItem.classList.add('flickity-play-button-container')
						toggleButton.classList.add('flickity-play-button')
						
						if (this.pageDots && this.pageDots.holder) {
							this.pageDots.holder.appendChild(toggleButtonItem)
						}
						
						this.on('select', () => toggleButton.classList.toggle('paused', this.player.state == 'playing'))

						const flkty = this
						toggleButton.addEventListener('click', function(e) {
							e.stopPropagation()
							
							switch (flkty.player.state) {
							case 'stopped':
								flkty.playPlayer()
								userPaused = false
								break
							case 'paused':
								flkty.unpausePlayer()
								userPaused = false
								break
							case 'playing':
								flkty.pausePlayer()
								userPaused = true
								break
							}
							
							this.classList.toggle('paused', flkty.player.state == 'playing')
							toggleButton.setAttribute(
								'aria-label',
								flkty.player.state === 'playing' ? 'Wiedergabe pausieren' : 'Wiedergabe starten'
							)
						})
					},

					scroll(progress) {
						const { cells, selectedIndex } = this
						const { length } = cells

						// KORRIGIERT: Verwende MediaHelper statt Media
						const colOffset = MediaHelper.isAbove('m') ?
							[5.5/12, 1/12] :
							MediaHelper.isAbove('s') ?
								[2/8, 2/8] :
								[0, 0]

						cells.forEach((cell, i) => {
							let offset = progress * (length - 1) - i
							offset = (offset > length/2) ?
								offset - length :
								(offset < length/-2) ?
									offset + length :
									offset

							const x = cell.size.width * (offset>0?colOffset[0]:colOffset[1]) * offset
							const opacity = (1/2 - Math.abs(offset)) * 2

							// Defensive GSAP-Aufrufe
							if (monadHolds[i] && typeof Tween !== 'undefined') {
								Tween.set(monadHolds[i], { x })
							}
							if (slideTexts[i] && typeof Tween !== 'undefined') {
								Tween.set(slideTexts[i], { opacity })
							}
							if (miniMonads[i] && typeof Tween !== 'undefined') {
								Tween.set(miniMonads[i], { opacity })
							}
						})
					},
				}
			})

			// Focus Event Handlers
			flkty.element.addEventListener('focusin', (event) => {
				event.preventDefault()
				
				if (typeof flkty.pausePlayer === 'function') {
					flkty.pausePlayer()
				}
				
				const cellElement = event.target.closest('.cell')
				if (cellElement) {
					const cellInstance = flkty.getCell(cellElement)
					if (cellInstance) {
						const cellIndex = flkty.getCellSlideIndex(cellInstance)
						if (cellIndex != flkty.selectedIndex && cellIndex !== -1) {
							flkty.select(cellIndex, false, true)
						}
					}
				}
				
				if (event.target && event.target.focus) {
					try {
						event.target.focus({ preventScroll: true })
					} catch (error) {
						event.target.focus()
					}
				}
			})

			flkty.element.addEventListener('focusout', (event) => {
				if (!userPaused && typeof flkty.unpausePlayer === 'function') {
					flkty.unpausePlayer()
				}
			})

			console.log('✅ Banner Start Monad Slider erfolgreich initialisiert')

		} catch (error) {
			console.error('❌ Fehler beim Initialisieren Banner Start Monad Slider:', error)
		}
	})
}

// ===================================
// BANNER THEME MONADS SLIDER
// ===================================

function initBannerThemeMonads() {
	if (!checkDependencies()) return
	
	console.log('🎠 Initialisiere Banner Theme Monads')

	$$('.banner-theme-monads').forEach((slider) => {
		try {
			const imageHolds = $$('.hold-image', slider)
			const solidHolds = $$('.hold-solid', slider)
			const slideTexts = $$('.slide-text', slider)
			let userPaused = false

			console.log('🔧 Theme Monad Slider Setup:', {
				imageHolds: imageHolds.length,
				solidHolds: solidHolds.length,
				slideTexts: slideTexts.length
			})

			const flkty = new Flickity($('.flickity-flow', slider), {
				contain: true,
				wrapAround: true,
				autoPlay: 4000,
				adaptiveHeight: true,
				prevNextButtons: true,
				pageDots: true,
				pauseAutoPlayOnHover: false,
				selectedAttraction: 0.0125,
				friction: 0.2,
				on: {
					ready() {
						console.log('✅ Theme Monad Slider ready')
						
						// update scroll CB wrt progress
						var positionX = -this.x - this.slides[0].target
						var progress = positionX / this.slidesWidth
						this.options.on.scroll.call(this, progress)

						// set prev/next buttons to non focusable
						if (this.prevButton && this.prevButton.element) {
							this.prevButton.element.tabIndex = -1
						}
						if (this.nextButton && this.nextButton.element) {
							this.nextButton.element.tabIndex = -1
						}

						// set up play/pause button
						const toggleButton = document.createElement('button')
						toggleButton.setAttribute('aria-label', 'Wiedergabe starten')
						const toggleButtonItem = document.createElement('li')
						toggleButtonItem.appendChild(toggleButton)
						toggleButtonItem.classList.add('flickity-play-button-container')
						toggleButton.classList.add('flickity-play-button')
						
						if (this.pageDots && this.pageDots.holder) {
							this.pageDots.holder.appendChild(toggleButtonItem)
						}
						
						this.on('select', () => toggleButton.classList.toggle('paused', this.player.state == 'playing'))

						const flkty = this
						toggleButton.addEventListener('click', function(e) {
							e.stopPropagation()
							
							switch (flkty.player.state) {
							case 'stopped':
								flkty.playPlayer()
								userPaused = false
								break
							case 'paused':
								flkty.unpausePlayer()
								userPaused = false
								break
							case 'playing':
								flkty.pausePlayer()
								userPaused = true
								break
							}
							
							this.classList.toggle('paused', flkty.player.state == 'playing')
							toggleButton.setAttribute(
								'aria-label',
								flkty.player.state === 'playing' ? 'Wiedergabe pausieren' : 'Wiedergabe starten'
							)
						})
					},

					scroll(progress) {
						const { cells } = this
						const { length } = cells

						// KORRIGIERT: Verwende MediaHelper statt Media
						const colOffset = MediaHelper.isAbove('m') ?
							[5.5/12, 0] :
							MediaHelper.isAbove('s') ?
								[3.5/8, 3.5/8] :
								[0, 0]

						cells.forEach((cell, i) => {
							let offset = progress * (length - 1) - i
							offset = (offset > length/2) ?
								offset - length :
								(offset < length/-2) ?
									offset + length :
									offset

							const x = cell.size.width * (offset>0?colOffset[0]:colOffset[1]) * offset
							const opacity = (1/2 - Math.abs(offset)) * 2

							// Defensive GSAP-Aufrufe
							if (imageHolds[i] && typeof Tween !== 'undefined') {
								Tween.set(imageHolds[i], { x })
							}
							if (slideTexts[i] && typeof Tween !== 'undefined') {
								Tween.set(slideTexts[i], { opacity })
							}
							if (solidHolds[i] && typeof Tween !== 'undefined') {
								Tween.set(solidHolds[i], { opacity })
							}
						})
					},
				}
			})

			// Focus Event Handlers  
			flkty.element.addEventListener('focusin', (event) => {
				event.preventDefault()
				
				if (typeof flkty.pausePlayer === 'function') {
					flkty.pausePlayer()
				}
				
				const cellElement = event.target.closest('.cell')
				if (cellElement) {
					const cellInstance = flkty.getCell(cellElement)
					if (cellInstance) {
						const cellIndex = flkty.getCellSlideIndex(cellInstance)
						if (cellIndex != flkty.selectedIndex && cellIndex !== -1) {
							flkty.select(cellIndex, false, true)
						}
					}
				}
				
				if (event.target && event.target.focus) {
					try {
						event.target.focus({ preventScroll: true })
					} catch (error) {
						event.target.focus()
					}
				}
			})

			flkty.element.addEventListener('focusout', (event) => {
				if (!userPaused && typeof flkty.unpausePlayer === 'function') {
					flkty.unpausePlayer()
				}
			})

			console.log('✅ Banner Theme Monad Slider erfolgreich initialisiert')

		} catch (error) {
			console.error('❌ Fehler beim Initialisieren Banner Theme Monad Slider:', error)
		}
	})
}

// ===================================
// RESIZE HANDLING
// ===================================

function handleMonadSliderResize() {
	// Flickity resize für alle Banner Slider
	[...$$('.banner-start-monads'), ...$$('.banner-theme-monads')].forEach(slider => {
		const flickityFlow = $('.flickity-flow', slider)
		if (flickityFlow) {
			const flkty = Flickity.data(flickityFlow)
			if (flkty) {
				flkty.resize()
				console.log('🔄 Monad Slider resized')
			}
		}
	})
}

// Debounced resize event
function debounce(func, wait) {
	let timeout
	return function executedFunction(...args) {
		const later = () => {
			clearTimeout(timeout)
			func(...args)
		}
		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
	}
}

window.addEventListener('resize', debounce(handleMonadSliderResize, 250))

// ===================================
// DEBUGGING FUNKTIONEN
// ===================================

window.debugMonadSliders = function() {
	console.group('🔍 Monad Slider Debug')
	console.log('Current Breakpoint:', MediaHelper.getCurrentBreakpoint())
	console.log('Window Size:', window.innerWidth + 'x' + window.innerHeight)
	
	const startSliders = $$('.banner-start-monads')
	const themeSliders = $$('.banner-theme-monads')
	
	console.log('Banner Start Monads:', startSliders.length)
	console.log('Banner Theme Monads:', themeSliders.length)
	
	console.groupEnd()
}

// ===================================
// INITIALISIERUNG
// ===================================

function initMonadSliders() {
	console.log('🎬 Initialisiere alle Monad Slider')
	
	// Warte bis DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function() {
			initBannerStartMonads()
			initBannerThemeMonads()
			
			// Debug nach kurzer Verzögerung
			setTimeout(() => {
				if (typeof window.debugMonadSliders === 'function') {
					window.debugMonadSliders()
				}
			}, 1000)
		})
	} else {
		initBannerStartMonads()
		initBannerThemeMonads()
		
		// Debug nach kurzer Verzögerung
		setTimeout(() => {
			if (typeof window.debugMonadSliders === 'function') {
				window.debugMonadSliders()
			}
		}, 1000)
	}
}

// Warten auf Dependencies
if (typeof Flickity !== 'undefined' && typeof Tween !== 'undefined') {
	initMonadSliders()
} else {
	// Polling für Dependencies
	let attempts = 0
	const maxAttempts = 50
	
	const waitForDependencies = setInterval(() => {
		attempts++
		
		if (typeof Flickity !== 'undefined' && typeof Tween !== 'undefined') {
			clearInterval(waitForDependencies)
			console.log('✅ Monad Slider Dependencies geladen nach', attempts, 'Versuchen')
			initMonadSliders()
		} else if (attempts >= maxAttempts) {
			clearInterval(waitForDependencies)
			console.error('❌ Monad Slider Dependencies konnten nicht geladen werden nach', maxAttempts, 'Versuchen')
		}
	}, 100)
}